import type { ShopRoutingLocationRuleDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@babackapp/ui/components/dialog";
import { useCallback } from "react";
import { RoutingLocationRuleForm } from "./routing-location-rule-form";

type Props = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  selectedRule: ShopRoutingLocationRuleDto;
  onCloseForm: () => void;
};

export const EditRoutingLocationRulesDialog = ({
  isOpen,
  setIsOpen,
  selectedRule,
}: Props) => {
  const t = useTranslation();
  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="pt-10">
        <DialogHeader>
          <DialogTitle>
            {t("settings.shipping.rules.updateRuleTitle")}
          </DialogTitle>
          <DialogDescription>
            {t("settings.shipping.rules.ruleDescription")}
          </DialogDescription>
        </DialogHeader>
        <RoutingLocationRuleForm
          routingLocationRule={selectedRule}
          onCloseForm={onClose}
        />
      </DialogContent>
    </Dialog>
  );
};
